<template>
  <div>
    <div id="preloader" v-show="loading">
      <div id="status">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </div>
    </div>

    <!-- Navbar STart -->
    <header id="topnav" class="defaultscroll sticky nav-sticky">
      <div class="container-xl" :class="place?.place_logo ? 'container-place' : ''">
        <a class="logo" href="https://ubbimed.com.br">
            <img :src="require('@/assets/images/logo_ubbi.png')" class="logo-light-mode" alt="Ubbimed">
            <img :src="place?.place_logo" v-if="place?.place_logo && $route.meta.scheduling"
                 class="logo-light-mode" alt="">
        </a>
        <div class="buy-button">
          <ThemeToggle />
          <div v-if="isAuthenticated">
            <router-link class="btn btn-link" to="/schedules">
              <div v-if="userAuth?.user_photo">
                <img :src="url(userAuth.user_photo)"
                     class="avatar avatar-small rounded-circle shadow" alt="Minha Foto" style="width: 40px; height: 40px">
                {{userAuth?.first_name}}
              </div>
              <div v-else>
                <span style="font-size: 20px; padding-right: 0; padding-left: 0" class="avatar avatar-small rounded-circle shadow pt-1 pb-1 d-lg-none">
                  {{initialsName()}}
                </span>
                <span class="d-none d-sm-inline">{{userAuth?.first_name}}</span>
              </div>
            </router-link>
          </div>
          <div v-else>

              <div class="btn-group dropdown-primary">
                  <button type="button" class="btn btn-ghost" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Entrar
                  </button>
                  <div class="dropdown-menu dropdown-menu-end">
                      <router-link to="/login" class="dropdown-item">
                          Sou paciente
                      </router-link>
                      <a href="https://professional.ubbimed.com.br/login" class="dropdown-item">Sou profissional</a>
                  </div>
              </div>

              <div class="btn-group dropdown-primary">
                  <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Cadastre-se
                  </button>
                  <div class="dropdown-menu dropdown-menu-end">
                      <router-link to="/register" class="dropdown-item">
                          Sou paciente
                      </router-link>
                      <a href="https://professional.ubbimed.com.br/register" class="dropdown-item">Sou profissional</a>
                  </div>
              </div>
          </div>
        </div>

        <div class="menu-extras">
          <div class="menu-item">
            <a class="navbar-toggle" id="isToggle" @click="toggleMenu">
              <div class="lines">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
          </div>
        </div>

        <div id="navigation">
          <ul class="navigation-menu">
            <li>
              <router-link to="/" class="sub-menu-item">Home</router-link>
            </li>
            <li>
              <a href="https://ubbimed.com.br/index.html#us" class="sub-menu-item">Quem somos</a>
            </li>
            <li>
              <a href="https://ubbimed.com.br/index.html#how_works" class="sub-menu-item">Como funciona</a>
            </li>
            <li>
              <a :href="urlProfessional" class="sub-menu-item">Para Profissionais</a>
            </li>
          </ul>

          <div class="buy-menu-btn d-none">
            <div v-if="isAuthenticated">
              <router-link to="/schedules" class="btn btn-link">
                {{userAuth.first_name}}
              </router-link>
              <button class="btn btn-link" type="button" title="Sair" @click="logout">
                <i class="fas fa-sign-out-alt"></i>
              </button>
            </div>
            <div v-else>
              <router-link to="/login" class="btn btn-link">
                Entrar
              </router-link>
              <router-link to="/register" class="btn btn-primary">
                Cadastre-se
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div :class="{ 'place-theme': isProfessionalProfile }" :style="placeTheme">
      <router-view/>
    </div>

    <footer class="footer footer-border">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
            <a href="#" class="logo-footer">
              <img :src="require('@/assets/images/logo_ubbi.png')" alt="">
            </a>
            <p class="mt-4">Consultas e exames a preços acessíveis, na palma da sua mão.</p>
            <ul class="list-unstyled social-icon foot-social-icon mb-0 mt-4">
              <li class="list-inline-item">
                <a href="https://www.facebook.com/ubbimed" target="_blank" class="rounded">
                  <i class="fab mt-2 fa-facebook"></i>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a href="https://www.instagram.com/ubbimed" target="_blank" class="rounded">
                  <i class="fab mt-2 fa-instagram"></i>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a href="https://twitter.com/MedUbbi" target="_blank" class="rounded">
                  <i class="fab mt-2 fa-twitter"></i>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a href="https://www.linkedin.com/company/ubbimed" target="_blank" class="rounded">
                  <i class="fab mt-2 fa-linkedin-in"></i>
                </a>
              </li>
              <li class="list-inline-item ms-1">
                <a href="https://www.youtube.com/channel/UCmOKmvrCvOZs0x30Q_6rB0Q" target="_blank" class="rounded">
                  <i class="fab mt-2 fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>

          <div class="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="footer-head">Empresa</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <a href="https://ubbimed.com.br/index.html#us" class="text-foot">
                  <i class="uil uil-angle-right-b me-1"></i>
                  Sobre
                </a>
              </li>
              <li>
                <router-link to="/login" class="text-foot">
                  <i class="uil uil-angle-right-b me-1"></i>
                  Login
                </router-link>
              </li>
              <li>
                <router-link to="/register" class="text-foot">
                  <i class="uil uil-angle-right-b me-1"></i>
                  Cadastre-se
                </router-link>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="footer-head">Links</h5>
            <ul class="list-unstyled footer-list mt-4">
              <li>
                <a target="_blank" href="https://policies.ubbimed.com.br/terms.php" class="text-foot">
                  <i class="uil uil-angle-right-b me-1"></i>
                  Termos de uso
                </a>
              </li>
              <li>
                <a target="_blank" href="https://policies.ubbimed.com.br/privacy.php" class="text-foot">
                  <i class="uil uil-angle-right-b me-1"></i>
                  Política de privacidade
                </a>
              </li>
              <li>
                <a :href="urlProfessional" class="text-foot">
                  <i class="uil uil-angle-right-b me-1"></i>
                  Para profissionais
                </a>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <h5 class="footer-head">App</h5>
            <p class="mt-4">Marque consulta de qualquer lugar.</p>
            <div class="d-flex flex-column align-items-start gap-2 mt-3">
              <a href="https://apps.apple.com/br/app/ubbimed/id6743162312" target="_blank" rel="noopener" class="store-badge">
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.4 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.2-2.8.9-3.5.9s-1.8-.8-3-.8c-1.6 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.3 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7 2-.1 2.9-2.3c.7-1.2 1-2.4 1-2.4s-2.3-1-2.3-3.9zM14.7 6.3c.6-.8 1.1-1.9.9-3-1 .1-2.1.7-2.8 1.5-.6.7-1.2 1.9-.9 2.9 1.1.1 2.1-.6 2.8-1.4z"/></svg>
                <span><small>Baixar na</small><strong>App Store</strong></span>
              </a>
              <a href="https://play.google.com/store/apps/details?id=br.com.ubbimed.app" target="_blank" rel="noopener" class="store-badge">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#34A853" d="M3.2 21.3 13 12 3.2 2.7v18.6z"/><path fill="#FBBC04" d="m16.6 8.4-3.6 3.6 3.6 3.6 4.4-2.5c.8-.5.8-1.7 0-2.2l-4.4-2.5z"/><path fill="#4285F4" d="M3.2 21.3c.4.7 1.3.8 2 .4L16.6 15.6 13 12z"/><path fill="#EA4335" d="M13 12 3.2 2.7c-.7-.4-1.6-.3-2 .4L13 12z"/></svg>
                <span><small>Disponível no</small><strong>Google Play</strong></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <footer class="footer footer-bar">
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="text-sm-start">
              <p class="mb-0">© {{new Date().getFullYear()}} Ubbimed. Feito em Araras.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import {initTemplate, toggleMenu} from "@/assets/js/app.js";
import str from "@/helpers/str";
import Swal from "sweetalert2";
import http from "@/helpers/http";
import ThemeToggle from "./ThemeToggle.vue";

export default {
  name: "Guest",
  components: {
    ThemeToggle,
  },
  data() {
    return {
      loading: true,
    }
  },
  mounted() {
    this.loading = false;
    initTemplate();
    this.ensurePlaceColor();
  },
  watch: {
    isProfessionalProfile() {
      this.ensurePlaceColor();
    },
    '$route.query.place'() {
      this.ensurePlaceColor();
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['auth/isAuth'];
    },
    userAuth() {
      return this.$store.state.auth.user;
    },
    urlProfessional() {
      return this.$store.state.urlProfessional;
    },
      place() {
          return this.$store.state.toSchedule.place;
      },
    isProfessionalProfile() {
      return (this.$route.path || '').startsWith('/professional/');
    },
    storedPlaceColor() {
      return this.$store.state.professionalProfile.placeColor
        || this.$store.state.professionalProfile.schedule.professional?.place_color;
    },
    placeColor() {
      return this.storedPlaceColor || '#780f5a';
    },
    placeTheme() {
      if (!this.isProfessionalProfile) {
        return {};
      }
      return { '--place-color': this.placeColor };
    },
  },
  methods: {
    toggleMenu: toggleMenu,
      url(path) {
          return str.url(path)
      },
    initialsName() {
      return str.initialsName(this.userAuth?.user_name);
    },
    ensurePlaceColor() {
      if (!this.isProfessionalProfile) {
        return;
      }
      if (this.storedPlaceColor) {
        if (!this.$store.state.professionalProfile.placeColor) {
          this.$store.commit('professionalProfile/setPlaceColor', this.storedPlaceColor);
        }
        return;
      }
      const placeId = this.$route.query.place
        || this.$store.state.professionalProfile.schedule.professional?.id_place;
      if (!placeId) {
        return;
      }
      http.get(`/places/${placeId}/data`).then((response) => {
        if (response.data?.place_color) {
          this.$store.commit('professionalProfile/setPlaceColor', response.data.place_color);
        }
      });
    },
    logout() {
      Swal.fire({
        title: 'Sair',
        text: "Tem certeza que deseja sair?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#780f5a',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, Sair!',
        cancelButtonText: "Não"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch('auth/logout').then(() => {
            this.$router.push('/');
          });
        }
      })
    },
  }
}
</script>

<style scoped>
@media (min-width: 1400px) {
    .container-place {
        max-width: 1240px !important;
    }
}
</style>

<style>
.place-theme {
  --place-color: #780f5a;
}

.place-theme .bg-primary,
.place-theme .btn-primary,
.place-theme .btn-outline-primary:hover,
.place-theme .btn-outline-primary:focus,
.place-theme .btn-outline-primary:active,
.place-theme .btn-outline-primary.active,
.place-theme .nav-pills .nav-link.active,
.place-theme .form-check-input:checked,
.place-theme .ribbon.ribbon-warning span {
  background-color: var(--place-color) !important;
}

.place-theme .text-primary,
.place-theme .btn-outline-primary,
.place-theme .btn-link,
.place-theme a,
.place-theme .pricing-rates.business-rate:hover .title {
  color: var(--place-color) !important;
}

.place-theme .btn-primary,
.place-theme .btn-outline-primary,
.place-theme .form-control:focus,
.place-theme .form-check-input:checked,
.place-theme .pricing-rates.business-rate:hover {
  border-color: var(--place-color) !important;
}

.place-theme .btn-link:hover,
.place-theme a:hover {
  color: color-mix(in srgb, var(--place-color) 72%, #000) !important;
}

.place-theme .ribbon.ribbon-warning span:before {
  border-left-color: var(--place-color);
  border-top-color: var(--place-color);
}

.place-theme .ribbon.ribbon-warning span:after {
  border-right-color: var(--place-color);
  border-top-color: var(--place-color);
}

.place-theme .btn-primary {
  box-shadow: none !important;
}
</style>